"use strict";
/**
 * Google Analytics v4
 * see https://redbox.outletcity.com/confluence/display/TUB/Google+Analytics+4+%28GA4%29+E-Commerce+Tracking
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackGA4Purchase = exports.pushGA4CustomEvent = exports.pushGA4Event = void 0;
const dataLayer_1 = __importDefault(require("./dataLayer"));
const analytics4Mappings_1 = require("./analytics4Mappings");
const pushGA4Event = (name, payload) => {
    const event = {
        event: name,
        ga4_ecommerce: payload,
    };
    (0, dataLayer_1.default)(event, { clearEcommerceObject: true });
};
exports.pushGA4Event = pushGA4Event;
const pushGA4CustomEvent = (name, payload) => {
    const event = {
        event: name,
        category: undefined,
        action: undefined,
        label: undefined,
        attributes: undefined,
        type: undefined,
        ...payload,
    };
    (0, dataLayer_1.default)(event);
};
exports.pushGA4CustomEvent = pushGA4CustomEvent;
const trackGA4Purchase = ({ currency, orderID, orderTotal, paymentMethod, products, shipping, type, voucher, voucherInternalName, voucherValue, }) => {
    const payload = {
        items: (0, analytics4Mappings_1.getGA4Items)(products),
        currency,
        value: Number(orderTotal),
        orderType: type === "1" ? "newCustomer" : "existingCustomer",
        transaction_id: orderID,
        shipping: Number(shipping),
        payment_type: paymentMethod,
        ...(voucher && { coupon: voucher }),
        ...(voucherInternalName && { couponDescription: voucherInternalName }),
        ...(voucherValue && { couponValue: voucherValue }),
    };
    (0, exports.pushGA4Event)("purchase", payload);
};
exports.trackGA4Purchase = trackGA4Purchase;
